/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';
import handleEvalReportError from './evalErrors';

export default class EvalBatchReportService extends BaseService {
  constructor() {
    super(constants.GET_EVAL_BATCH_REPORT, 'EvalReportBatchReportStatus');
  }

  async handleEvent(eventName, event) {
    const { tenantId, executionId } = event;
    const headers = utils.buildHeadersWithTenantId({ tenantId });
    const url = `${constants.EVAL_RESULT_URL}/${encodeURIComponent(executionId)}/report`;
    const { isStackB } = utils.getStackBParams();
    const clientName = isStackB ? 'aiadminstackbv2' : 'aiadmin';

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient(clientName).get(url, { headers: enhancedHeaders });
    }
    return this.getClient(clientName).get(url, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('evalResultData').setBatchReportResponse(response.data);
  }

  handleError(error) {
    handleEvalReportError(error);
    Framework.getStoreRegistry().getStore('evalResultData').failBatchReportRequest();
  }
}
